import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "text-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#text-colors" }),
  /*#__PURE__*/_createTextVNode(" Text Colors ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use extended text helper classes defined in "),
  /*#__PURE__*/_createVNode("code", null, "sass/helpers/_text.scss"),
  /*#__PURE__*/_createTextVNode(" for more advance use cases. Colorize text with color utilities as shown ")
], -1)
const _hoisted_6 = { class: "py-5" }
const _hoisted_7 = { class: "rounded border p-10" }
const _hoisted_8 = { class: "py-5" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="text-white"></div>
            <div class="text-primary"></div>
            <div class="text-secondary"></div>
            <div class="text-light"></div>
            <div class="text-success"></div>
            <div class="text-info"></div>
            <div class="text-warning"></div>
            <div class="text-danger"></div>
            <div class="text-dark"></div>
            <div class="text-muted"></div>
            <div class="text-gray-100"></div>
            <div class="text-gray-200"></div>
            <div class="text-gray-300"></div>
            <div class="text-gray-400"></div>
            <div class="text-gray-500"></div>
            <div class="text-gray-600"></div>
            <div class="text-gray-700"></div>
            <div class="text-gray-800"></div>
            <div class="text-gray-900"></div>
            `))
const _hoisted_10 = { class: "py-10" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "light-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#light-colors" }),
  /*#__PURE__*/_createTextVNode(" Light Colors ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".text-light-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's light color defined with "),
  /*#__PURE__*/_createVNode("code", null, "$theme-light-colors"),
  /*#__PURE__*/_createTextVNode(" in "),
  /*#__PURE__*/_createVNode("code", null, "sass/_variables.scss"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_13 = { class: "py-5" }
const _hoisted_14 = { class: "rounded border p-10" }
const _hoisted_15 = { class: "py-5" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="text-light-primary bg-primary"></div>
            <div class="text-light-success bg-success"></div>
            <div class="text-light-info bg-info"></div>
            <div class="text-light-warning bg-warning"></div>
            <div class="text-light-danger bg-danger"></div>
            <div class="text-light-dark bg-dark"></div>
            `))
const _hoisted_17 = { class: "pt-10" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "inverse-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#inverse-colors" }),
  /*#__PURE__*/_createTextVNode(" Inverse Colors ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".text-inverse-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's inverse color defined with "),
  /*#__PURE__*/_createVNode("code", null, "$theme-inverse-colors"),
  /*#__PURE__*/_createTextVNode(" in "),
  /*#__PURE__*/_createVNode("code", null, "sass/_variables.scss"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_20 = { class: "py-5" }
const _hoisted_21 = { class: "rounded border p-10" }
const _hoisted_22 = { class: "py-5" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="text-inverse-white bg-white"></div>
            <div class="text-inverse-primary bg-primary"></div>
            <div class="text-inverse-secondary bg-secondary"></div>
            <div class="text-inverse-light bg-light"></div>
            <div class="text-inverse-success bg-success"></div>
            <div class="text-inverse-info bg-info"></div>
            <div class="text-inverse-warning bg-warning"></div>
            <div class="text-inverse-danger bg-danger"></div>
            <div class="text-inverse-dark bg-dark"></div>
            `))
const _hoisted_24 = { class: "pt-10" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "inverse-hover-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#inverse-hover-colors" }),
  /*#__PURE__*/_createTextVNode(" Inverse Hover Colors ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".text-hover-inverse-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's hover inverse color defined with "),
  /*#__PURE__*/_createVNode("code", null, "$theme-inverse-colors"),
  /*#__PURE__*/_createTextVNode(" in "),
  /*#__PURE__*/_createVNode("code", null, "sass/_variables.scss"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_27 = { class: "py-5" }
const _hoisted_28 = { class: "rounded border p-10" }
const _hoisted_29 = { class: "py-5" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="text-hover-inverse-white bg-hover-white"></div>
            <div class="text-hover-inverse-primary bg-hover-primary"></div>
            <div class="text-hover-inverse-secondary bg-hover-secondary"></div>
            <div class="text-hover-inverse-light bg-hover-light"></div>
            <div class="text-hover-inverse-success bg-hover-success"></div>
            <div class="text-hover-inverse-info bg-hover-info"></div>
            <div class="text-hover-inverse-warning bg-hover-warning"></div>
            <div class="text-hover-inverse-danger bg-hover-danger"></div>
            <div class="text-hover-inverse-dark bg-hover-dark"></div>
            `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.textColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [[
                  `text-${item}`,
                  item === 'white' && `bg-dark`,
                  item === 'light' && `bg-dark`,
                  item === 'gray-100' && `bg-dark`
                ], "p-3 fw-bold fw-6"]
              }, " .text-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.lightColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`text-light-${item} bg-${item}`, "p-3 fw-bold fw-6"]
              }, " .text-light-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.inverseColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`text-inverse-${item} bg-${item}`, "p-3 fw-bold fw-6"]
              }, " .text-inverse-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_24, [
        _hoisted_25,
        _hoisted_26,
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.inverseColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`text-hover-inverse-${item} bg-hover-${item}`, "p-3 fw-bold fw-6"]
              }, " .text-hover-inverse-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}